module.exports = {"brokerAddr":""}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/environments/overrides.json
// module id = 1496
// module chunks = 0